import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../../UI/Button/Button';
import {hideOverlay} from '../../../actions/overlay-actions';
import Translation from '../../../lang/Translation';
import Spacing from '../../../style-helper/Spacing';
import CheckoutOverlay from '../CheckoutOverlay';

const useStyles = createUseStyles({
  postalIdInfoOverlay: {
    fontSize: 16,
  },
  buttonContainer: {
    marginTop: '1em',
  },
  step: {
    marginTop: Spacing.double,
  },
});

export function PostalIdInfoOverlay(props) {
  const classes = useStyles();
  return (
    <CheckoutOverlay
      popup
      className={classes.postalIdInfoOverlay}
      data-test="PostalIdInfoOverlay"
      title="checkout.delivery.address.field.postal.id.hint.overlay.title"
    >
      <div data-test="PostalIdInfoOverlay__helpText">
        <Translation>checkout.delivery.address.field.postal.id.info.text</Translation>
      </div>
      <div className={classes.step} data-test="PostalIdInfoOverlay__helpLine">
        <Translation>checkout.delivery.address.field.postal.id.info.text.first</Translation>
      </div>
      <div className={classes.step} data-test="PostalIdInfoOverlay__helpLine">
        <Translation>checkout.delivery.address.field.postal.id.info.text.second</Translation>
      </div>
      <div className={classes.step} data-test="PostalIdInfoOverlay__helpLine">
        <Translation>checkout.delivery.address.field.postal.id.info.text.third</Translation>
      </div>
      <div className={classes.step} data-test="PostalIdInfoOverlay__helpLine">
        <Translation>checkout.delivery.address.field.postal.id.info.text.fourth</Translation>
      </div>
      <div
        className={classes.buttonContainer}
        data-test="PostalIdInfoOverlay__buttonContainer"
      >
        <Button
          id="PostalIdInfoOverlay__closeButton"
          className="PostalIdInfoOverlay__closeButton"
          primary
          fullWidth
          onClick={props.hideOverlay}
        >
          <Translation>checkout.close.button</Translation>
        </Button>
      </div>
    </CheckoutOverlay>
  );
}

PostalIdInfoOverlay.propTypes = {
  hideOverlay: PropTypes.func.isRequired,
};

export default connect(
  null,
  {hideOverlay},
)(PostalIdInfoOverlay);
